import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import Icon from '/@/components/icon';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { trackEvent } from '/@/store/tracking';
import useWindowSize from '/@/utils/hooks/window-size';
import { reverse } from '/@/utils/router';
import Title from '/@/v3/components/title';
import Background from './assets/bg.svg';
import MapImage from './assets/map-image.svg';

const FrostRiskLanding = () => {
    const history = useNavigate();
    const isDesktop = useWindowSize().width || 0 > 900;
    const dispatch = useDispatch();
    const cardData = [
        {
            title: _('Proyección de GDUs antes y después de la siembra'),
            content: _(
                'Obtené una proyección del pronóstico de GDUs esperados para 7 días antes y después de tu fecha de siembra en tus lotes.'
            ),
            button: _('Ver pronóstico'),
            key: 3,
        },
        {
            title: _('Mapas GDUs acumulados a 7 y a 14 días'),
            content: _('Mapa de riesgo térmico en función de acumulación de GDUs diarios en los próximos días.'),
            button: _('Ver mapa'),
            key: 1,
        },
        {
            title: _('Pronóstico de temperaturas mínimas'),
            content: _(
                'Una proyección de las escalas más bajas de temperatura de todos tus lotes, categorizados por localidad.'
            ),
            button: _('Ver pronóstico'),
            key: 2,
        },
    ];

    const handleClick = (key) => {
        if (key) {
            if (key === 1) {
                dispatch(trackEvent({ key: 'frost_risk.frost_risk_map.GDU_7' }));
            } else {
                dispatch(trackEvent({ key: 'frost_risk.frost_risk_map.minimal_temp' }));
            }

            history(
                reverse('frost_risk_map', {
                    qs: { id: key },
                })
            );
        } else {
            dispatch(trackEvent({ key: 'frost_risk.frost_risk.forecast' }));
            history(reverse('frost_risk_map'));
        }
    };

    return (
        <Grid container>
            <Grid item xs={12} sx={{ height: { md: '60vh' }, backgroundImage: `url(${Background})` }}>
                <Grid
                    container
                    spacing={isDesktop ? 2 : 0}
                    md={9}
                    xs={12}
                    sx={{
                        background: 'rgba(0, 0, 0, 0.5)',
                        mx: 'auto',
                        my: 6,
                        p: 2,
                        maxWidth: { lg: '1200px !important' },
                    }}
                >
                    <Grid
                        item
                        container
                        direction='column'
                        justifyContent='center'
                        spacing={2}
                        xs={12}
                        md={4}
                        sx={{ mx: { lg: 3 } }}
                    >
                        <Grid item container spacing={2} alignItens='center' sx={{ flexWrap: 'nowrap' }}>
                            <Grid item sx={{ width: 'fit-content' }}>
                                <Icon type='frostRisk' size='xxl' style={{ filter: 'brightness(0) invert(1)' }} />
                            </Grid>
                            <Grid item sx={{ width: 'fit-content' }}>
                                <Title color='white' size='xl' bolder>
                                    {_('Mapa de riesgo de helada')}
                                </Title>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Title color='white' size='sm'>
                                {_(
                                    'Te mostraremos los mapas de riesgo de heladas para los próximos días. Una herramienta ideal para poder definir tu fecha de siembra. '
                                )}
                            </Title>
                        </Grid>
                        <Grid item>
                            <Button fullWidth variant='contained' onClick={() => handleClick(1)} color='white'>
                                {_('Ver mapa')}
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={7} sx={{ m: 'auto', pt: { xs: 2, md: 0 } }}>
                        <img src={MapImage} style={{ width: '-webkit-fill-available', maxWidth: 500 }} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item container spacing={2} justifyContent='center' sx={{ mt: { md: -8 } }}>
                {cardData.map((cd) => {
                    return (
                        <Grid item sx={{ width: { xs: '100%', md: 'auto' } }}>
                            <Card variant='outlined' sx={{ maxWidth: { xs: '100%', md: 400 }, p: 4, height: '100%' }}>
                                <Grid
                                    container
                                    direction='column'
                                    justifyContent='space-between'
                                    sx={{ height: '100%' }}
                                >
                                    <Grid item>
                                        <CardContent>
                                            <Grid container direction='column' spacing={1}>
                                                <Grid item>
                                                    <Title bolder theme={settings.app.theme} size='lg'>
                                                        {cd.title}
                                                    </Title>
                                                </Grid>
                                                <Grid item>
                                                    <Title color='gray-dark' size='md'>
                                                        {cd.content}
                                                    </Title>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Grid>
                                    <Grid item>
                                        <CardActions>
                                            <Button
                                                fullWidth
                                                size='small'
                                                variant='contained'
                                                onClick={() => handleClick(cd.key)}
                                            >
                                                {cd.button}
                                            </Button>
                                        </CardActions>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </Grid>
    );
};

export default FrostRiskLanding;
